/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difficulty_EasyInputs */

const bn_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সহজ`)
};

const de_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfach`)
};

const el_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εύκολος`)
};

const en_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easy`)
};

const es_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fácil`)
};

const fr_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facile`)
};

const hi_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आसान`)
};

const hu_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Könnyen`)
};

const id_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudah`)
};

const it_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facile`)
};

const ja_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`簡単`)
};

const ko_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쉬운`)
};

const nl_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eenvoudig`)
};

const pl_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łatwy`)
};

const pt_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fácil`)
};

const ru_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Легкий`)
};

const sv_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lätt`)
};

const tr_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolay`)
};

const uk_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`легко`)
};

const vi_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dễ`)
};

const zh_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简单的`)
};

const zh_hant_difficulty_easy = /** @type {(inputs: Difficulty_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`簡單的`)
};

/**
* | output |
* | --- |
* | "Easy" |
*
* @param {Difficulty_EasyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const difficulty_easy = /** @type {((inputs?: Difficulty_EasyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difficulty_EasyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_difficulty_easy(inputs)
	if (locale === "de") return de_difficulty_easy(inputs)
	if (locale === "el") return el_difficulty_easy(inputs)
	if (locale === "en") return en_difficulty_easy(inputs)
	if (locale === "es") return es_difficulty_easy(inputs)
	if (locale === "fr") return fr_difficulty_easy(inputs)
	if (locale === "hi") return hi_difficulty_easy(inputs)
	if (locale === "hu") return hu_difficulty_easy(inputs)
	if (locale === "id") return id_difficulty_easy(inputs)
	if (locale === "it") return it_difficulty_easy(inputs)
	if (locale === "ja") return ja_difficulty_easy(inputs)
	if (locale === "ko") return ko_difficulty_easy(inputs)
	if (locale === "nl") return nl_difficulty_easy(inputs)
	if (locale === "pl") return pl_difficulty_easy(inputs)
	if (locale === "pt") return pt_difficulty_easy(inputs)
	if (locale === "ru") return ru_difficulty_easy(inputs)
	if (locale === "sv") return sv_difficulty_easy(inputs)
	if (locale === "tr") return tr_difficulty_easy(inputs)
	if (locale === "uk") return uk_difficulty_easy(inputs)
	if (locale === "vi") return vi_difficulty_easy(inputs)
	if (locale === "zh") return zh_difficulty_easy(inputs)
	return zh_hant_difficulty_easy(inputs)
});